import React, { Component } from 'react';
import { CommentList } from './CommentList';
import Form from 'react-bootstrap/lib/Form';
import { Formik } from 'formik';
import { activeCommentsStore } from '../../../helpers/ActiveCommentsStore';

export class ActComments extends Component {
	constructor() {
		super();

		this.state = {
			commentState: false,
			hover: false
		};

		this.handleToggleClick = (e = {}) => {
			if (e.stopPropagation) {
				e.stopPropagation();
			}

			if (!this.state.commentState) {
				activeCommentsStore.setNew(this);
			}

			this.setState({ commentState: !this.state.commentState });
		};

		this.handleShowClick = (e = {}) => {
			if (e.stopPropagation) {
				e.stopPropagation();
			}

			activeCommentsStore.setNew(this);

			this.setState({ commentState: true });
		};

		this.handleHideClick = (e = {}) => {
			if (e.stopPropagation) {
				e.stopPropagation();
			}

			if (this.state.commentState) {
				this.setState({ commentState: false });
			}
		};

		this.handleMouseEnter = (e) => {
			if (e.target === this.elementText) {
				this.setState({
					hover: true
				});
			}
		};

		this.handleMouseLeave = (e) => {
			if (this.state.hover) {
				this.setState({
					hover: false
				});
			}
		};

		this.handleAllElementClick = (e = {}) => {
			if (e.stopPropagation) {
				e.stopPropagation();
			}
		};
	}

	render() {
		const {
			canComment,
			children,
			childrens,
			text,
			commentCount,
			showComment,
			canCommentAndSetOpinion,
			comments,
			id,
			projectId,
			loggedUserId,
			element = 'div',
			className = '',
			classNameCont = '',
			agreementAccepted = false,
			agreementAcceptedRequired = false,
			scrollToAgreement = Function.prototype,
			userId,
			showOpinion,
			isCommentAdding = false
		} = this.props;
		let newComment = {
			id: 0,
			content: '',
			actElementId: id,
			projectId: projectId,
			userId: userId ? userId : 0
		};
		const { commentState, hover } = this.state;
		const Element = element;
		const props = {};

		if (typeof element == 'string') {
			props.dangerouslySetInnerHTML = { __html: text };
		} else {
			props.children = text;
		}

		return (
			<div
				className={`act__element-cont${canComment ? ' act--can-comment' : ''}${hover || comments.length > 0
					? ' act--hover'
					: ''}`}
				onClick={this.handleAllElementClick}
			>
				<div
					className={`text act__element-text${classNameCont ? ` ${classNameCont}` : ''}${commentState &&
					canComment
						? ' act--selected'
						: ''}`}
					onClick={this.handleToggleClick}
				>
					<Element
						className={`act__element-text-inline${className ? ` ${className}` : ''}`}
						onMouseEnter={this.handleMouseEnter}
						onMouseLeave={this.handleMouseLeave}
						ref={(ref) => {
							this.elementText = ref;
						}}
						{...props}
					/>
					{children}
				</div>
				{canComment && (
					<div className={`act__comments${commentState ? ' act--over-other' : ''}`}>
						{!commentState && (
							<button className="act__button-show-comment" onClick={this.handleShowClick}>
								{`+${commentCount}`}
							</button>
						)}
						{commentState && (
							<div className="act__comments-box">
								<div className="act__comments-header">
									<div className="act__comments-title">Komentarze ({commentCount})</div>
									<i
										className="far fa-times-circle act__comments-close"
										onClick={this.handleHideClick}
									/>
								</div>
								{showComment && (
									<div className="act__comments-cont">
										<CommentList
											items={comments}
											canCommentAndSetOpinion={canCommentAndSetOpinion}
											addCommentOpinion={(id, type) => this.props.addCommentOpinion(id, type)}
											removeCommentOpinion={(id) => this.props.removeCommentOpinion(id)}
											opinionExecuting={this.props.opinionExecuting}
											agreementAccepted={agreementAccepted}
											agreementAcceptedRequired={agreementAcceptedRequired}
											scrollToAgreement={scrollToAgreement}
											showOpinion={showOpinion}
										/>
										{canCommentAndSetOpinion ? (
											<Formik
												enableReinitialize={true}
												initialValues={newComment}
												validateOnChange={false}
												render={({ values, handleChange, isValid, setValues }) => (
													<Form
														noValidate
														method="post"
														onSubmit={(e) => {
															e.preventDefault();
															if (agreementAcceptedRequired && !agreementAccepted) {
																scrollToAgreement();
															} else {
																this.props.saveComment(values);
																setValues(newComment);
															}
														}}
													>
														<textarea
															id={`content`}
															name={`content`}
															className="act__comments-textarea"
															value={values.content}
															onChange={handleChange}
														/>
														<div className="act__comments-btn-cont">
															<button
																className="act__comments-btn"
																disabled={
																	!isValid || this.props.disabled || isCommentAdding
																}
															>
																{isCommentAdding ? 'Dodaje...' : 'Dodaj'}
															</button>
														</div>
													</Form>
												)}
											/>
										) : (
											<div>
												<textarea className="act__comments-textarea" disabled />
											</div>
										)}
									</div>
								)}
							</div>
						)}
					</div>
				)}
			</div>
		);
	}
}
